export default {
  methods: {
    allowedStep: m => m % 5 === 0
  }
};
